module.exports = __webpack_public_path__ + "media/images/tto-logo-b25d1d0d66d49dcc6ea6cbe3a3c5b7e3.svg";